<template>
	<div>
		<!-- 备用金模式下的支付状态展示 -->
		<div class="info-payer-simple" v-if="hfdgLargePayBankMode == '1'">
			<div class="info-title">
				<div class="title-name">{{ $t('trade.TransferDetailOfBigAmount.629434-0') }}</div>
			</div>
			<div class="info-item">
				<div class="item-label">{{ $t('trade.TransferDetailOfBigAmount.629434-1') }}</div>：
				<div class="item-value" style="color:#FFBB66">{{statusText}}</div>
				<div class="item-refresh" style="color:#00c0ef;cursor: pointer;margin-left: 10px;" @click="refreshStatus">{{ $t('trade.TransferDetailOfBigAmount.629434-2') }}</div>
			</div>
		</div>

		<!-- 银行模式展示完整付款方信息 -->
		<div class="info-payer" v-if="hfdgLargePayBankMode != '1'">
			<div class="info-title">
				<div class="title-name">{{ $t('trade.TransferDetailOfBigAmount.629434-3') }}</div>
				<img src='../../assets/images/icon-tip.svg' class="title-icon" />
				<div class="title-tip">{{ $t('trade.TransferDetailOfBigAmount.629434-4') }}</div>
			</div>

			<div class="info-item">
				<div class="item-label">
					{{ $t('trade.TransferDetailOfBigAmount.629434-1') }}
				</div>：
				<div class="item-value" style="color:#FFBB66">
					{{statusText}}
				</div>
				<div class="item-refresh" style="color:#00c0ef;cursor: pointer;margin-left: 10px;" @click="refreshStatus">
					{{ $t('trade.TransferDetailOfBigAmount.629434-2') }}
				</div>
			</div>

			<div class="info-item">
				<div class="item-label">
					{{ $t('trade.TransferDetailOfBigAmount.629434-5') }}
				</div>：
				<div class="item-value text_2line">
					{{payerInfo.belongBankName}}
				</div>
			</div>

			<div class="info-item">
				<div class="item-label">
					{{ $t('trade.TransferDetailOfBigAmount.629434-6') }}
				</div>：
				<div class="item-value text_2line">
					{{payerInfo.accountName}}
				</div>
			</div>

			<div class="info-item">
				<div class="item-label">
					{{ $t('trade.TransferDetailOfBigAmount.629434-7') }}
				</div>：
				<div class="item-value text_2line">
					{{payerInfo.accountNumber}}
				</div>
			</div>

			<div class="info-item">
				<div class="item-label">
					{{ $t('trade.TransferDetailOfBigAmount.629434-8') }}
				</div>：
				<div class="item-value text_2line">
					{{payerInfo.openingBank}}
				</div>
			</div>

		</div>

		<div class="info-reciver">
			<div class="info-title">
				<div class="title-name">{{ $t('trade.TransferDetailOfBigAmount.629434-9') }}</div>
				<img src='../../assets/images/icon-tip.svg' class="title-icon" />
				<div class="title-tip">{{ $t('trade.TransferDetailOfBigAmount.629434-10') }}</div>
			</div>

			<div class="info-item">
				<div class="item-label">
					{{ $t('trade.TransferDetailOfBigAmount.629434-6') }}
				</div>：
				<div class="item-value">
					<div class="item-valuetxt text_2line">{{reciverInfo.accountName}}</div>
					<div class="item-copy" v-clipboard:copy="reciverInfo.accountName" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">{{ $t('common.action.copy') }}</div>
				</div>
			</div>

			<div class="info-item">
				<div class="item-label">
					{{ $t('trade.TransferDetailOfBigAmount.629434-7') }}
				</div>：
				<div class="item-value">
					<div class="item-valuetxt text_2line">{{reciverInfo.accountNumber}}</div>
					<div class="item-copy" v-clipboard:copy="reciverInfo.accountNumber" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">{{ $t('common.action.copy') }}</div>
				</div>
			</div>

			<div class="info-item">
				<div class="item-label">
					{{ $t('trade.TransferDetailOfBigAmount.629434-11') }}
				</div>：
				<div class="item-value">
					<div class="item-valuetxt text_2line">{{reciverInfo.belongBankName}}</div>
					<div class="item-copy" v-clipboard:copy="reciverInfo.belongBankName" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">{{ $t('common.action.copy') }}</div>
				</div>
			</div>
			<!-- <div class="info-item">
				<div class="item-label">
					开户行支行
				</div>：
				<div class="item-value">
					<div class="item-valuetxt text_2line">{{reciverInfo.belongBankName}}</div>
					<div class="item-copy" v-clipboard:copy="reciverInfo.belongBankName" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制</div>
				</div>
			</div> -->
		</div>

		<div class="transfer-btn">
			<el-button style="width: 40%;" @click="close">{{ $t('trade.TransferDetailOfBigAmount.629434-12') }}</el-button>
		</div>

	</div>
</template>

<script>
	import tradeUtils from '../../utils/api-utils/api-trade.js'
	import commonUtils from '../../utils/common-utlis.js'

	export default {
		name: "creditcard-list",
		props: {
			tradeNo: {
				type: String,
				default: ''
			},
			hfdgLargePayBankMode: {
				type: String,
				default: ''
			},

		},
		data() {
			return {
				payerInfo: {},
				reciverInfo: {},
				statusText: this.$t('trade.TransferDetailOfBigAmount.629434-13')
			}
		},
		created() {
			// 获取转账详情
			this.getTransferDetail()
		},
		methods: {
			/**
			 * 获取转账详情
			 */
			async getTransferDetail() {
				// 获取crm收款账户信息
				let bigAmountPayInfoList = await tradeUtils.getCombinePayInfo(this.tradeNo);

				let transferDetail = bigAmountPayInfoList[0] || {};
				
				this.payerInfo = {
					belongBankName: transferDetail.belongBankName || '',
					accountName: transferDetail.userAccountName || '',
					accountNumber: transferDetail.userAccountNumber || '',
					openingBank: transferDetail.openingBank || '',
				}

				this.reciverInfo = {
					belongBankName: transferDetail.receiveBankName || '',
					accountName: transferDetail.receiveAcctNoName || '',
					accountNumber: transferDetail.receiveAcctNo || '',
				}
			},

			/**
			 * 关闭弹窗
			 */
			close() {
				// 通知父组件修改状态
				this.$emit('close', this.statusText);
			},


			/**
			 * 复制成功
			 */
			onCopySuccess() {
				this.$message({
					message: this.$t('goods.GoodsLinkCopyDialog.348313-6'),
					type: 'success',
				});
			},

			/**
			 * 复制失败
			 */
			onCopyError(e) {
				this.$message.error({
					message: this.$t('goods.GoodsLinkCopyDialog.348313-7')
				});
			},

			/**
			 * 刷新状态
			 */
			refreshStatus: commonUtils.debounce(async function(e) {
				let tradeStatus = await tradeUtils.getTradeStatus(this.tradeNo);

				this.$message({
					message: this.$t('trade.TransferDetailOfBigAmount.629434-14'),
					type: 'success',
				});

				if ([2, 16].includes(tradeStatus)) {
					this.statusText = this.$t('trade.TransferDetailOfBigAmount.629434-15')
					//this.gotoTradeDetail()
				}
			}, 400, false),

		}
	}
</script>

<style scoped>
	.info-payer {
		margin-bottom: 20px;
	}

	.info-payer-simple {
		margin-bottom: 20px;
		padding: 15px;
		background-color: #f5f7fa;
		border-radius: 4px;
	}

	.info-title {
		display: flex;
		align-items: center;
		margin-bottom: 15px;
	}

	.title-name {
		font-weight: bold;
		font-size: 16px;
	}

	.title-icon {
		width: 17px;
		margin: 0 5px 0 10px;
		transform: translateY(1px);
	}

	.title-tip {
		color: #FFBB66;
	}

	.info-item {
		display: flex;
		align-items: center;
		margin-bottom: 8px;
	}

	.item-value {
		color: #999;
		display: flex;
		align-items: center;
		max-width: 250px;
		text-overflow: ellipsis;
	}

	.item-valuetxt {
		max-width: 200px;
		text-overflow: ellipsis;
	}

	.item-copy {
		margin-left: 10px;
		color: #00c0ef;
		cursor: pointer;
	}

	.transfer-btn {
		margin-top: 30px;
		text-align: center;
	}

	.text_2line {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		/*设置对其模式 */
		-webkit-line-clamp: 2;
		/*设置多行的行数*/
	}
</style>